import React from "react";
import PublicPageLayout from "./PublicPageLayout";

const news = [
  ["平台持續更新中", "我們持續改善工作管理、車隊協作與配送現場的使用體驗。"],
  ["更清楚的工作流程", "讓管理者、司機與收件者，在各自需要的地方看到正確資訊。"],
];

export default function News() {
  return (
    <PublicPageLayout
      title="最新消息"
      intro="這裡會整理 Tallarge 的功能更新與服務進度。"
    >
      <div className="public-page-list">
        {news.map(([title, text]) => (
          <article className="public-page-row" key={title}>
            <h2>{title}</h2>
            <p>{text}</p>
          </article>
        ))}
      </div>
    </PublicPageLayout>
  );
}
